import React from "react";
import { Redirect } from 'react-router-dom';
import Test from "../Test/Test"

const FrontPage = (props) => {

  return (
    <>

<div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center bg-light"
  style={{
    backgroundImage: "url('/assets/images/bg3.jpg')", // Ensure this is a light-themed image
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    height: '400px',
    position: 'relative' // Set position to relative for the overlay
  }}
>
    {/* Light overlay */}
    <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.5)', // Light overlay for a softer effect
      /* zIndex: 1 // Ensure the overlay is above the background image */
    }}
  />

    <div className="col-md-5 p-lg-5 mx-auto my-5" style={{color: "#0059B6"}}>
      <h1 className="display-4 fw-normal" style={{color: "#ff6200", textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)"}}>DeviceHub</h1>
      <p className="lead fw-normal">Smart Management for Wi-Fi Controllers and Connected Devices</p>
      {/* <a data-mdb-ripple-init className="btn btn-primary btn-lg" role="button" href="/device_list">Device List</a> */}
    </div>
    <div className="product-device shadow-sm d-none d-md-block"></div>
    <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
  </div>

   {/* <Test /> */}
    </>
  )
}

export default FrontPage;